import React, { useCallback } from 'react';
import {
  ReactFlow,
  MiniMap,
  ReactFlowProvider,
  Controls,
  BaseEdge,
  useNodeId,
  NodeResizer,
  NodeToolbar,
  Handle,
  Position,
  EdgeTypes,
  Background,
  useNodesState,
  useConnection,
  ControlButton,
  useEdgesState,
  useEdges,
  Panel,
  useNodes,
  addEdge,
  getStraightPath,
} from '@xyflow/react';

import CustomEdge from './CustomEdge';
 
import '@xyflow/react/dist/style.css';
 
const initialNodes = [
  { id: '1', position: { x: 0, y: 0 }, data: { label: '1' },type: 'selectorNode',  },
  { id: '2', position: { x: 0, y: 100 }, data: { label: '2', type: 'ResizableNode', } },
];
const initialEdges = [{ id: 'e1-2', source: '1', target: '2',label:"mesh",type: 'step', }];

function Connection () {
    const connection = useConnection();
    const edges = useEdges();
   
    return (
      <>
      <div>There are currently {edges.length} edges!</div>
        {connection &&
          <div>
            Someone is trying to make a connection from {JSON.stringify(connection.fromNode)} to this one.
          </div>
        }
        {!connection &&
          <div>
            There are currently no incoming connections!
          </div>
        }
      </>
    )
  }
function Sidebar() {
    // This hook will only work if the component it's used in is a child of a
    // <ReactFlowProvider />.
    const nodes = useNodes()
   
    return (
      <aside>
        {nodes.map((node) => (
          <div key={node.id}>
            Node {node.id} -
              x: {node.position.x.toFixed(2)},
              y: {node.position.y.toFixed(2)}
          </div>
        ))}
      </aside>
    )
  }
  const CustomNode = ({ data }: { data: { label: string , toolbarVisible: boolean,  type: string } }) => {
    const nodeId = useNodeId();
    return (
      <>
        <div className='className="nodrag"'>
          <NodeToolbar isVisible={true} >
            <button>delete</button>
            <button>copy</button>
            <button>expand</button>
          </NodeToolbar>
          <NodeResizer minWidth={100} minHeight={30} />
          <div className='custom-node' style={{ padding: '10px 20px' }}>
            {data.label}ID={nodeId}
          </div>
    
          <Handle type="target" position={Position.Left} />
          <Handle type="source" position={Position.Right} />
        </div>
      </>
    );
  };

  const edgeTypes: EdgeTypes = {
    custom: CustomEdge,
  };

  const nodeTypes = {
    selectorNode: CustomNode,
  };

  
 
export default function App() {
  const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes);
  const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);
 
  const onConnect = useCallback(
    (params:any) => setEdges((eds) => addEdge(params, eds)),
    [setEdges],
  );
 
  return (
    <div style={{ width: '70vw', height: '100vh' }}>
        <ReactFlowProvider>
      <ReactFlow
        nodes={nodes}
        edges={edges}
        nodeTypes={nodeTypes}
        edgeTypes={edgeTypes}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onConnect={onConnect}
      >
        <Controls>
        <ControlButton onClick={() => alert('Something magical just happened. ✨')}>
          ss
        </ControlButton>
      </Controls>

        <Panel position='top-right'>menus</Panel>
        <MiniMap />
        <Background gap={12} size={1} />
      </ReactFlow>
      <Sidebar />
      <Connection />
     
      </ReactFlowProvider>

    </div>
  );
}